import Phaser from "phaser";
import { FALLING_GRAVITY, ENEMY_FONT_SIZE } from "../config";

/** 落下文字演出（当たり判定なし） */
export class FallingChar {
  private text: Phaser.GameObjects.Text;
  private velocityY: number;
  private alive: boolean;

  constructor(scene: Phaser.Scene, x: number, y: number, char: string) {
    this.text = scene.add.text(x, y, char, {
      fontSize: `${ENEMY_FONT_SIZE}px`,
      fontFamily: "'Hiragino Kaku Gothic Pro', 'Meiryo', sans-serif",
      color: "#00ff88",
    });
    this.text.setOrigin(0.5, 0.5);
    this.velocityY = 0;
    this.alive = true;
  }

  /** 毎フレーム更新 */
  update(dt: number): void {
    if (!this.alive) return;
    this.velocityY += FALLING_GRAVITY * dt;
    this.text.y += this.velocityY * dt;

    // 透明度を徐々に下げる
    const alpha = this.text.alpha - 0.5 * dt;
    if (alpha <= 0) {
      this.alive = false;
      this.text.destroy();
    } else {
      this.text.setAlpha(alpha);
    }
  }

  /** 生存チェック */
  isAlive(): boolean {
    return this.alive;
  }

  /** 破棄 */
  destroy(): void {
    this.alive = false;
    if (this.text && this.text.active) {
      this.text.destroy();
    }
  }
}
